import { render, staticRenderFns } from "./results-suggestions.vue?vue&type=template&id=367fd2ae&"
import script from "./results-suggestions.vue?vue&type=script&lang=ts&"
export * from "./results-suggestions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports